module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_8017.c29fb86f.png";